import "./App.css";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Login from "./pages/LoginPage";
import { useSelector, useDispatch } from "react-redux";
import { getUserInfo } from "./store/user";
import { useEffect } from "react";
import Sidebar from "./components/Sidebar";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import Locations from "./pages/Locations";
import SingleLocation from "./pages/SingleLocation";
import NotFound from "./pages/NotFound";

function App() {
  const { token } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const ProtectedRoute = ({ children }) => {
    if (!token) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  useEffect(() => {
    if (token !== null) {
      dispatch(getUserInfo());
    } else {
      navigate("/login");
    }
  }, [dispatch, navigate, token]);

  return (
    <div className="flex">
      <Sidebar />
      <div className="pl-8 pr-8 pt-6 pb-6 w-full">
        <Routes>
          <Route path="login" element={<Login />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<Login />} />
          <Route
            path="locations"
            element={
              <ProtectedRoute>
                <Locations />
              </ProtectedRoute>
            }
          />
          <Route
            path="locations/:id"
            element={
              <ProtectedRoute>
                <SingleLocation />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default App;
